import type { ShareObject } from '../types/ShareObject';

export default function getShareUrlPath(shareObject: ShareObject) {
  let pathStart;

  switch (shareObject.type) {
    case 'map':
    case 'custom_route':
      pathStart = 'explore/custom-routes/';
      break;
    case 'track':
      pathStart = 'explore/recording/';
      break;
    case 'list':
      pathStart = 'lists/';
      break;
    default:
      pathStart = '';
  }
  return `${pathStart}${shareObject.slug}`;
}
